module.exports = __webpack_public_path__ + "static/img/47.af45102c.png";